import fixImages from './fixImages';

export default {
  'fix-images': fixImages
};